export enum OS {
  ANDROID = 'android',
  IOS = 'ios',
}
